import { IUbicacionCommand, IUbicacionCommandEliminar, IUbicacionEdit, IUbicacionRequest } from "../../Interfaces/auxiliar/IUbicacion";
import { Ifilter } from "../../Interfaces/filter";
import { IUbicacionOculto } from "../../Interfaces/hazard/IHazard";
import { fetchListVerificacion } from "../http-common";

const ubicacion = "Ubicacion";

const TablaUbicacion = (request: IUbicacionRequest) => {
    return fetchListVerificacion.post(`${ubicacion}/ListarByNivel`, request);
};
const TablaUbicacionCompleto = (request: IUbicacionRequest) => {
    return fetchListVerificacion.post(`${ubicacion}/ListarByNivelCompleto`, request);
};

const UpdateUbicacion = (request: IUbicacionEdit) => {
    return fetchListVerificacion.put(`${ubicacion}/Actualizar`, request);
};
const OcultarUbicacion = (request: IUbicacionOculto) => {
    return fetchListVerificacion.put(`${ubicacion}/OcultarUbicacion`, request);
};

const CreateUbicacion = (request: IUbicacionCommand) => {
    return fetchListVerificacion.post(`${ubicacion}/Crear`, request);
};
const CreateUbicacionCompleto = (request: IUbicacionCommand) => {
    return fetchListVerificacion.post(`${ubicacion}/CrearCompleto`, request);
};

const ComboUbicacion = (request: Ifilter, controller = new AbortController()) => {
    return fetchListVerificacion.post(`${ubicacion}/ComboUbicacion`, request, {
        signal: controller.signal,
    });
};

const EliminarUbicacion = (command: IUbicacionCommandEliminar) => {
    return fetchListVerificacion.delete(`${ubicacion}/Eliminar`, {
        params: command
    });
}

const UbicacionService = {
    TablaUbicacion,
    UpdateUbicacion,
    CreateUbicacion,
    ComboUbicacion,
    EliminarUbicacion,TablaUbicacionCompleto,CreateUbicacionCompleto,OcultarUbicacion
}

export default UbicacionService;